export default __webpack_public_path__ + "static/media/accounting_point_9_en.5280520c.png";